import Util from '~/assets/javascripts/util'

export default (context, inject) => {
  inject('util', Util)
}
